module.exports = __webpack_public_path__ + "img/logo.a0038693.png";